<template>
  <div class="mt20 step-one-wrapper">
    <div class="one-title">基本信息</div>
    <avue-form ref="form"
               v-model="orderForm"
               :option="orderOption"
               @submit="handleSubmit"
               @error="error">
      <template slot="menuForm"
                v-if="!isDetail">
        <el-button type="primary"
                   size="mini"
                   @click="goNextHandle">下一步</el-button>
      </template>
      <template slot="residenceAddressLabel">
        <span>详细地址：</span>
        <div>
          <el-checkbox v-model="checked"
                       @change="asyncAddress">同步户籍</el-checkbox>
        </div>
      </template>
      <template slot="qsgx">
        <kinship :isShowTitle="false"
                 :isShowBtn="!isDetail"
                 :list="orderForm.basisArchiveKinshipList"
                 :orderId="orderForm.id"
                 @getList="getKinshipHandle"></kinship>
      </template>
      <!--  <template slot="gjfpz">
                <orderjudicial :isShowTitle="false" :isShowBtn="!isDetail" :list="orderForm.starOrderJudicialList" :orderId="orderId" @getList="getjudicialHandle"></orderjudicial>
            </template> -->
      <template slot="relation">
        <relation :isShowTitle="false"
                  :isShowBtn="!isDetail"
                  :list="orderForm.basisArchiveRelationList"
                  :orderId="orderForm.id"
                  @getList="getRelationHandle"></relation>
      </template>
      <template slot="zfjl">
        <followRecord :isShowTitle="false"
                      :isShowBtn="!isDetail"
                      :list="orderForm.basisArchiveInterviewList"
                      :dossierId="orderForm.id"
                      @getList="getFollowListHandle"></followRecord>
      </template>
    </avue-form>
    <div class="mt10 tac"
         v-if="isDetail">
      <el-button type="primary"
                 size="mini"
                 @click="goNextHandle">下一步</el-button>
    </div>
  </div>
</template>
<script>
import kinship from '@/components/kinship/index.vue'
import relation from '@/components/relation/index.vue'
import followRecord from '@/components/followRecord/index.vue'
// import orderjudicial from '@/components/orderjudicial/index.vue'
import { cardid, isvalidatemobile } from '@/util/validate'
import website from '@/config/website';
import { add, update } from "@/api/archives/index";
import { getDetail } from '@/api/base/region'
import { deepClone, getInfoFromIdCard } from '@/util/util'
import { mapGetters } from "vuex";
export default {
  components: {
    kinship,
    // orderjudicial,
    relation,
    followRecord
  },
  props: {
    data: {
      type: Object,
      default: {}
    },
    isDetail: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: ''
    }
  },
  watch: {
    data: {
      deep: true,
      handler (val) {
        let column1 = this.orderOption.group.find(v => v.prop == 'zf')
        column1.display = this.data.id ? true : false
        getDetail(this.data.basisArchivePersonalData.residenceRegionCode).then(data1 => {
          this.data.basisArchivePersonalData.residenceProvince = data1.data.data.provinceCode
          this.data.basisArchivePersonalData.residenceCity = data1.data.data.cityCode
          this.data.basisArchivePersonalData.residenceDistrict = data1.data.data.districtCode
          getDetail(this.data.basisArchivePersonalData.actualResidenceRegionCode).then(data2 => {
            this.data.basisArchivePersonalData.actualResidenceProvince = data2.data.data.provinceCode
            this.data.basisArchivePersonalData.actualResidenceCity = data2.data.data.cityCode
            this.data.basisArchivePersonalData.actualResidenceDistrict = data2.data.data.districtCode
            this.orderForm = this.data
            console.log(this.orderForm)
          })
        })
      }
    }
  },
  data () {
    var checkCardid = (rule, value, callback) => {
      let list = cardid(value);
      if (list[0]) {
        return callback(new Error(list[1]));
      } else {
        callback();
      }
    };
    var checkPhone = (rule, value, callback) => {
      let list = isvalidatemobile(value);
      if (list[0]) {
        return callback(new Error(list[1]));
      } else {
        callback();
      }
    };
    return {
      checked: false,
      orderForm: {},
      orderOption: {
        size: 'mini',
        detail: this.isDetail,
        submitText: '保存',
        emptyBtn: false,
        labelWidth: 120,
        column: [{
          label: "个案编号",
          prop: "basisArchiveNo",
          row: true,
          span: 24,
          disabled: true,
          placeholder: '系统自动生成'
        },
        {
          label: '选择区域',
          prop: 'residenceProvince',
          bind: 'basisArchivePersonalData.residenceProvince',
          type: 'select',
          props: {
            label: 'name',
            value: 'code'
          },
          cascaderItem: ['residenceCity', 'residenceDistrict'],
          dicUrl: '/api/blade-system/region/select',
          span: 6,
          labelslot: true,
          rules: [{
            required: true,
            message: "选择区域",
            trigger: "blur"
          }],
        },
        {
          labelWidth: 0,
          label: '',
          prop: 'residenceCity',
          bind: 'basisArchivePersonalData.residenceCity',
          type: 'select',
          props: {
            label: 'name',
            value: 'code'
          },
          cascaderItem: ['residenceDistrict'],
          dicFlag: false,
          dicUrl: '/api/blade-system/region/select?code={{key}}',
          span: 4,
        },
        {
          labelWidth: 0,
          label: '',
          prop: 'residenceDistrict',
          bind: 'basisArchivePersonalData.residenceDistrict',
          type: 'select',
          props: {
            label: 'name',
            value: 'code'
          },
          dicFlag: false,
          dicUrl: '/api/blade-system/region/select?code={{key}}',
          span: 4,
        },
        {
          // label: "选择机构",
          // prop: "archiveCreateDept",
          // type: "select",
          // multiple: true,
          // addDisplay: false,
          // editDisplay: false,
          // searchOrder: 1,
          // filterable: true,
          // viewDisplay: website.tenantMode,
          // hide: !website.tenantMode,
          // span: 10,
          // dicUrl: "/api/blade-order/order/getDeptList",
          // props: {
          //     label: "deptName",
          //     value: "id"
          // },
          // rules: [{
          //     required: true,
          //     message: "请选择机构",
          //     trigger: "click"
          // }]



          label: "选择机构",
          prop: "archiveCreateDept",
          dataType: 'string',
          type: 'tree',
          // multiple: true,
          addDisplay: false,
          editDisplay: false,
          searchOrder: 1,
          filterable: true,
          viewDisplay: website.tenantMode,
          hide: !website.tenantMode,
          span: 10,
          checkStrictly: true,
          leafOnly: false,
          dicUrl: "/api/blade-system/dept/tree",
          props: {
            label: 'title'
          },

          rules: [{
            required: true,
            message: "请选择机构",
            trigger: "click"
          }],


        }
        ],
        group: [{
          label: '基本信息',
          prop: 'baseInfo',
          column: [{
            label: "上传照片",
            prop: "photoUrl",
            type: 'upload',
            listType: 'picture-img',
            bind: 'basisArchivePersonalData.photoUrl',
            loadText: '图片上传中，请稍等',
            tip: '只能上传jpg/png用户头像，且不超过500kb',
            // formslot: true,
            action: '/api/blade-resource/oss/endpoint/put-file-attach',
            propsHttp: {
              res: 'data',
              url: 'link'
            },
            data: {
              fileName: 'photoUrl'
            },
            span: 24,
          }, {
            label: "姓名",
            prop: "name",
            bind: 'basisArchivePersonalData.name',
            hide: true,
            rules: [{
              required: true,
              message: "请填写姓名",
              trigger: "blur"
            }],
          }, {
            label: "爱好",
            prop: "hobby",
            bind: 'basisArchivePersonalData.hobby',
            hide: true,
          }, {
            label: "身份证",
            prop: "cardNo",
            bind: 'basisArchivePersonalData.cardNo',
            hide: true,
            rules: [{
              required: true,
              trigger: "blur",
              validator: checkCardid
            }],
            blur: (value) => {
              if (!cardid(value.value)[0]) {
                let obj = getInfoFromIdCard(value.value)
                this.orderForm.birthday = obj.birthday
                this.orderForm.gender = obj.sex
                this.orderForm.basisArchivePersonalData.birthday = obj.birthday
                this.orderForm.basisArchivePersonalData.gender = obj.sex
              }
            },
          }, {
            label: "出生年月",
            prop: "birthday",
            bind: 'basisArchivePersonalData.birthday',
            type: "date",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            hide: true,
          },
          {
            label: "健康状况",
            prop: "healthyState",
            bind: 'basisArchivePersonalData.healthyState',
            type: 'select',
            dataType: "number",

            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
              code: 'healthy'
            },
            props: {
              label: "dictValue",
              value: "dictKey"
            }
          },
          {
            label: "籍贯",
            prop: "nativePlace",
            bind: 'basisArchivePersonalData.nativePlace',
            rules: [{
              required: true,
              message: "请填写籍贯",
              trigger: "blur"
            }],
          },

          {
            label: "电话",
            prop: "contact",
            bind: 'basisArchivePersonalData.contact',
            rules: [{
              required: true,
              trigger: "blur",
              validator: checkPhone
            }],
          },
          {
            label: "性别",
            prop: "gender",
            bind: 'basisArchivePersonalData.gender',
            type: 'select',
            dataType: "number",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
              code: 'sex'
            },
            props: {
              label: "dictValue",
              value: "dictKey"
            },
          },
          {
            label: '户籍地址',
            prop: 'residenceProvince',
            bind: 'basisArchivePersonalData.residenceProvince',
            type: 'select',
            props: {
              label: 'name',
              value: 'code'
            },
            cascaderItem: ['residenceCity', 'residenceDistrict'],
            dicUrl: '/api/blade-system/region/select',
            span: 8,
            rules: [{
              required: true,
              message: "请选择户籍地址",
              trigger: "blur"
            }],
            change: (value) => {
              if (this.checked) {
                this.orderForm.actualResidenceProvince = value.value
                this.orderForm.basisArchivePersonalData.actualResidenceProvince = value.value
              }
              if (this.$refs.form) {
                this.$refs.form.clearValidate()
              }
            }
          },
          {
            labelWidth: 0,
            label: '',
            prop: 'residenceCity',
            bind: 'basisArchivePersonalData.residenceCity',
            type: 'select',
            props: {
              label: 'name',
              value: 'code'
            },
            cascaderItem: ['residenceDistrict'],
            dicFlag: false,
            dicUrl: '/api/blade-system/region/select?code={{key}}',
            span: 8,
            change: (value) => {
              if (this.checked) {
                this.orderForm.actualResidenceCity = value.value
                this.orderForm.basisArchivePersonalData.actualResidenceCity = value.value
              }
              if (this.$refs.form) {
                this.$refs.form.clearValidate()
              }
            }
          },
          {
            labelWidth: 0,
            label: '',
            prop: 'residenceDistrict',
            bind: 'basisArchivePersonalData.residenceDistrict',
            type: 'select',
            props: {
              label: 'name',
              value: 'code'
            },
            dicFlag: false,
            dicUrl: '/api/blade-system/region/select?code={{key}}',
            span: 8,
            change: (value) => {
              if (this.checked) {
                this.orderForm.actualResidenceDistrict = value.value
                this.orderForm.basisArchivePersonalData.actualResidenceDistrict = value.value
              }
              if (this.$refs.form) {
                this.$refs.form.clearValidate()
              }
            }
          },
          {
            label: "详细地址",
            prop: "residenceAddress",
            bind: 'basisArchivePersonalData.residenceAddress',
            span: 24,
            rules: [{
              required: true,
              message: "请填写户籍地址",
              trigger: "blur"
            }],
            labelslot: true,
            change: (value) => {
              if (this.checked) {
                this.orderForm.actualResidentialAddress = value.value
                this.orderForm.basisArchivePersonalData.actualResidentialAddress = value.value
              }
              if (this.$refs.form) {
                this.$refs.form.clearValidate()
              }
            }
          }, {
            label: '居住地址',
            prop: 'actualResidenceProvince',
            bind: 'basisArchivePersonalData.actualResidenceProvince',
            type: 'select',
            props: {
              label: 'name',
              value: 'code'
            },
            cascaderItem: ['actualResidenceCity', 'actualResidenceDistrict'],
            dicUrl: '/api/blade-system/region/select',
            span: 8,
            labelslot: true,
            rules: [{
              required: true,
              message: "请选择居住地址",
              trigger: "blur"
            }],
            change: (value) => {
              if (this.$refs.form) {
                this.$refs.form.clearValidate()
              }
            }
          },
          {
            labelWidth: 0,
            label: '',
            prop: 'actualResidenceCity',
            bind: 'basisArchivePersonalData.actualResidenceCity',
            type: 'select',
            props: {
              label: 'name',
              value: 'code'
            },
            cascaderItem: ['actualResidenceDistrict'],
            dicFlag: false,
            dicUrl: '/api/blade-system/region/select?code={{key}}',
            span: 8,
            change: (value) => {
              if (this.$refs.form) {
                this.$refs.form.clearValidate()
              }
            }
          },
          {
            labelWidth: 0,
            label: '',
            prop: 'actualResidenceDistrict',
            bind: 'basisArchivePersonalData.actualResidenceDistrict',
            type: 'select',
            props: {
              label: 'name',
              value: 'code'
            },
            dicFlag: false,
            dicUrl: '/api/blade-system/region/select?code={{key}}',
            span: 8,
            change: (value) => {
              if (this.$refs.form) {
                this.$refs.form.clearValidate()
              }
            }
          },
          {
            label: "居住地址",
            prop: "actualResidentialAddress",
            bind: 'basisArchivePersonalData.actualResidentialAddress',
            span: 24,
            rules: [{
              required: true,
              message: "请填写居住地址",
              trigger: "blur"
            }],
            blur: (value) => {
              if (this.$refs.form) {
                this.$refs.form.clearValidate()
              }
            }
          }, {
            label: '类型',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
              code: 'Five-youth_types'
            },
            formatter: (row, value, label, column) => {
              return label
            },
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            prop: "teenagersType",
            bind: 'basisArchivePersonalData.teenagersType',
            search: true,
            row: true
          }, {
            label: "综合特质",
            prop: "comprehensive",
            bind: 'basisArchivePersonalData.comprehensive',
            type: "textarea",
            span: 24,
          }, {
            label: "身高",
            prop: "height",
            bind: 'basisArchivePersonalData.height',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
              code: 'height'
            },
            props: {
              label: "dictValue",
              value: "dictKey"
            },
          }, {
            label: "体重",
            prop: "weight",
            bind: 'basisArchivePersonalData.weight',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
              code: 'weight'
            },
            props: {
              label: "dictValue",
              value: "dictKey"
            },
          }, {
            label: "情绪",
            prop: "mood",
            bind: 'basisArchivePersonalData.mood',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
              code: 'emotional'
            },
            props: {
              label: "dictValue",
              value: "dictKey"
            },
          }, {
            label: "性格",
            prop: "byCharacter",
            bind: 'basisArchivePersonalData.byCharacter',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
              code: 'character'
            },
            props: {
              label: "dictValue",
              value: "dictKey"
            },

          }, {
            label: "性格说明",
            prop: "characterRemark",
            bind: 'basisArchivePersonalData.characterRemark',
            type: "textarea",
            span: 24,
          }, {
            label: "就读状况",
            prop: "studentStatus",
            bind: 'basisArchivePersonalData.studentStatus',
            type: "select",
            dataType: "number",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
              code: 'Academic_status'
            },
            props: {
              label: "dictValue",
              value: "dictKey"
            },
          }, {
            label: "学校",
            prop: "school",
            bind: 'basisArchivePersonalData.school'
          },
          {
            label: "年级",
            prop: "theGrade",
            bind: 'basisArchivePersonalData.theGrade'
          },
          {
            label: "班级",
            prop: "theClass",
            bind: 'basisArchivePersonalData.theClass'
          },
          {
            label: "学籍号",
            prop: "studentNo",
            bind: 'basisArchivePersonalData.studentNo'
          },
          {
            label: "学习成绩",
            prop: "studyResult",
            bind: 'basisArchivePersonalData.studyResult',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
              code: 'academic_record'
            },
            props: {
              label: "dictValue",
              value: "dictKey"
            },
          },
          {
            label: "学习经历",
            prop: "studyExperience",
            bind: 'basisArchivePersonalData.studyExperience',
            type: "textarea",
            placeholder: "小学毕业于XXX中心小学；初中毕业于XXX中；目前就读于福州市XXX中学；XXX自述学习成绩一般，较少主动和同学交流互动，放学后都准时回家，偶尔早放学时会与同学一起打篮球。",
            span: 24
          },
          {
            label: "就业状况",
            prop: "employmentStatus",
            bind: 'basisArchivePersonalData.employmentStatus',
            type: "select",
            dataType: "number",
            dicData: [{
              label: '已就业',
              value: 0
            }, {
              label: '未就业',
              value: 1
            }]
          }, {
            label: "就业单位",
            prop: "employmentUnit",
            bind: 'basisArchivePersonalData.employmentUnit'
          },
          {
            label: '家庭类型',
            prop: 'householdType',
            bind: 'basisArchivePersonalData.householdType',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
              code: 'household_type'
            },
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            span: 12,
          },
          {
            label: "家庭教养",
            prop: "familyUpbringing",
            bind: 'basisArchivePersonalData.familyUpbringing',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
              code: 'parenting_pattern'
            },
            props: {
              label: "dictValue",
              value: "dictKey"
            }
          },
          {
            label: "家庭经济",
            prop: "familyEconomy",
            bind: 'basisArchivePersonalData.familyEconomy',
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary",
            dicQuery: {
              code: 'Family-economic_status'
            },
            props: {
              label: "dictValue",
              value: "dictKey"
            },
          }, {
            label: "家庭经济备注",
            prop: 'familyNote',
            bind: 'basisArchivePersonalData.familyNote',
            type: 'textarea',
            span: 24,
            row: true
          }, {
            label: "曾经有使用相关服务记录",
            prop: "isServiceSituation",
            bind: 'basisArchivePersonalData.isServiceSituation',
            type: "select",
            dataType: "number",
            dicData: [{
              label: '没有',
              value: 0
            }, {
              label: '曾经有',
              value: 1
            }],
          }, {
            label: "曾经有注明",
            prop: "serviceSituationRemarks",
            bind: 'basisArchivePersonalData.serviceSituationRemarks'
          },
          {
            label: "现使用相关服务记录",
            prop: "serviceSituationRecord",
            bind: 'basisArchivePersonalData.serviceSituationRecord',
            type: "select",
            dataType: "number",
            dicData: [{
              label: '没有',
              value: 0
            }, {
              label: '现没有',
              value: 1
            }],
          }, {
            label: "现有注明",
            prop: "serviceSituationNow",
            bind: 'basisArchivePersonalData.serviceSituationNow'
          },
          {
            label: "内容",
            prop: "serviceSituationBody",
            bind: 'basisArchivePersonalData.serviceSituationBody',
            type: "textarea",
            span: 24,
          }
          ]
        },
        {
          label: '走访记录',
          prop: 'zf',
          display: false,
          column: [{
            labelPosition: 'top',
            prop: 'zfjl',
            formslot: true,
            span: 24
          }]
        },
        {
          label: '亲属关系',
          prop: 'qs',
          column: [{
            labelPosition: 'top',
            prop: 'qsgx',
            formslot: true,
            span: 24
          }]
        },
        {
          label: '人际关系',
          prop: 'rj',
          column: [{
            labelPosition: 'top',
            prop: 'relation',
            formslot: true,
            span: 24
          }]
        },
        ]
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted () {
    let column = this.findObject(this.orderOption.column, 'archiveCreateDept')
    column.disabled = (this.userInfo.account === 'admin' ? false : true)
    let column1 = this.orderOption.group.find(v => v.prop == 'zf')
    column1.display = this.data.id ? true : false
    if (this.data.basisArchivePersonalData) {
      getDetail(this.data.basisArchivePersonalData.residenceRegionCode).then(data1 => {
        this.data.basisArchivePersonalData.residenceProvince = data1.data.data.provinceCode
        this.data.basisArchivePersonalData.residenceCity = data1.data.data.cityCode
        this.data.basisArchivePersonalData.residenceDistrict = data1.data.data.districtCode
        getDetail(this.data.basisArchivePersonalData.actualResidenceRegionCode).then(data2 => {
          this.data.basisArchivePersonalData.actualResidenceProvince = data2.data.data.provinceCode
          this.data.basisArchivePersonalData.actualResidenceCity = data2.data.data.cityCode
          this.data.basisArchivePersonalData.actualResidenceDistrict = data2.data.data.districtCode
          this.orderForm = this.data
          console.log(this.orderForm)
        })
      })
    } else {
      setTimeout(() => {
        this.orderForm.archiveCreateDept = this.userInfo.dept_id
      }, 1000)
    }
  },
  methods: {
    asyncAddress (val) {
      if (val) {
        this.orderForm.basisArchivePersonalData.actualResidenceProvince = this.orderForm.actualResidenceProvince = this.orderForm.residenceProvince
        this.orderForm.basisArchivePersonalData.actualResidenceCity = this.orderForm.actualResidenceCity = this.orderForm.residenceCity
        this.orderForm.basisArchivePersonalData.actualResidenceDistrict = this.orderForm.actualResidenceDistrict = this.orderForm.residenceDistrict
        this.orderForm.basisArchivePersonalData.actualResidentialAddress = this.orderForm.actualResidentialAddress = this.orderForm.residenceAddress
      }
    },
    goNextHandle () {
      if (this.orderForm.id) {
        this.$emit("next", 1)
      } else {
        this.$message.error("请先完善基本信息")
      }
    },
    // 获取亲属关系回调
    getKinshipHandle (list) {
      this.$set(this.orderForm, 'orderKinshipList', list)
    },
    getjudicialHandle (list) {
      this.$set(this.orderForm, 'starOrderJudicialList', list)
    },
    getFollowListHandle (list) {
      this.$set(this.orderForm, 'dossierRecord', list)
    },
    getRelationHandle (list) {
      this.$set(this.orderForm, 'orderRelationList', list)
    },
    handleSubmit (form, done, loading) {
      let obj = deepClone(this.orderForm)
      this.$set(obj.basisArchivePersonalData, "residenceRegionCode", this.orderForm.basisArchivePersonalData.residenceDistrict || this.orderForm.basisArchivePersonalData.residenceCity || this.orderForm.basisArchivePersonalData.residenceProvince)
      this.$set(obj.basisArchivePersonalData, "actualResidenceRegionCode", this.orderForm.basisArchivePersonalData.actualResidenceDistrict || this.orderForm.basisArchivePersonalData.actualResidenceCity || this.orderForm.basisArchivePersonalData.actualResidenceProvince)
      this.$set(obj.basisArchivePersonalData, "residenceProvince", this.orderForm.$residenceProvince)
      this.$set(obj.basisArchivePersonalData, "residenceCity", this.orderForm.$residenceCity)
      this.$set(obj.basisArchivePersonalData, "residenceDistrict", this.orderForm.$residenceDistrict)
      this.$set(obj.basisArchivePersonalData, "actualResidenceProvince", this.orderForm.$actualResidenceProvince)
      this.$set(obj.basisArchivePersonalData, "actualResidenceCity", this.orderForm.$actualResidenceCity)
      this.$set(obj.basisArchivePersonalData, "actualResidenceDistrict", this.orderForm.$actualResidenceDistrict)
      console.log(obj)
      update(obj).then((res) => {
        // 获取新增数据的相关字段
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        // 数据回调进行刷新
        this.$refs.form.resetForm();
        done();
        this.$emit("refresh", res.data.data.id || '')
      }, error => {
        done();
        window.console.log(error);
      });
    },
    error (err) {
      this.$message.success('请填写完整信息');
    }
  }
}

</script>
<style lang="scss" scoped="scoped">
@import "@/styles/moudles/desk.scss";
</style>
<style lang="scss">
.step-one-wrapper {
  .one-title {
    padding: 30px 0;
    font-size: 20px;
    text-align: center;
  }
}
</style>
